<template>
    <div>
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center mb-2">
            <h3 class="mb-0 font-weight-semibold" style="font-size: 18px; color: #111827;">Pengiriman QR</h3>

            <div class="d-flex align-items-center">
                <div class="mr-3" style="font-size: 14px; color: #374151;">Saldo QR : {{ numberWithCommas(saldoQr) }}</div>

                <!-- Date range picker -->
                <div class="date-picker-wrapper mr-3">
                    <i class="far fa-calendar-alt calendar-icon"></i>
                    <flat-pickr v-model="dateValue" :config="dateRangeConfig"></flat-pickr>
                </div>

                <a class="btn btn-download-template" href="/template/Data pengiriman Sticker QR Code ke Dealer atau AHASS.xlsx">
                    <i class="far fa-file-alt mr-2"></i> Download Template
                </a>
            </div>
        </div>

        <!-- Summary cards -->
      

        <div class="row mt-3">
            <div class="col-md-4 mb-3" v-for="card in summaryCards" :key="card.key">
                <div class="summary-card">
                    <div class="summary-title">{{ card.title }}</div>
                    <div class="summary-value">{{ numberWithCommas(card.qty) }}</div>
                    <hr class="summary-divider" />
                    <div class="summary-sub">
                        <a v-if="card.link" href="#" class="summary-link" @click.prevent="showInTransit">
                            dari {{ card.count }} pengiriman
                        </a>
                        <span v-else>dari {{ card.count }} pengiriman</span>
                    </div>
                </div>
            </div>
        </div>

        <qr-issue
            class="mt-2"
            ref="qrIssue"
            :start-date="startDate"
            :end-date="endDate"
            @filterChange="tableFilter = $event"
            @editData="handleEditData"
            @showMetodeModal="modal.showMetodeModal = true"
        />

        <edit-pengiriman-modal
            ref="editModal"
            v-if="modal.showEditModal"
            @closeModal="modal.showEditModal = false"
            @updateTable="updateTable"
        />

        <metode-pengiriman-modal
            v-if="modal.showMetodeModal"
            @closeModal="modal.showMetodeModal = false"
            @updateTable="updateTable"
        />
    </div>
</template>

<script>
import moment from 'moment'
import qrIssue from './children/qrIssue.vue'

import EditPengirimanModal from './children/EditPengirimanModal.vue';
import MetodePengirimanModal from './children/MetodePengirimanModal.vue';



export default {
    metaInfo : {
        title : 'QR Issue'
    },
    components : {
        MetodePengirimanModal,
        EditPengirimanModal,
        qrIssue
    },
    data () {
        const start = moment().subtract(14, 'days').format('YYYY-MM-DD')
        const end = moment().format('YYYY-MM-DD')
        return {
            modal : {
                showMetodeModal : false,
                showEditModal: false
            },
            dataEdit : {
                id : '',
                package_code: '',
                kode_dealer : '',
                qty : 0,
                sender_signature : null,
            },
            saldoQr : 0,

            // tanggal (dikontrol parent, dikirim ke child lewat props)
            startDate: start,
            endDate: end,
            dateValue: `${start} to ${end}`,
            dateRangeConfig: {
                mode: 'range',
                altFormat: 'd-m-Y',
                dateFormat: 'Y-m-d',
                altInput: true,
                altInputClass: 'qr-flatpickr-alt',
                locale: { rangeSeparator: ' s/d ' },
                onClose: this.onCloseDate
            },

            highlight : {
                sent:      { qty: 0, shipment: 0, total_shipment: 0 },
                received:  { qty: 0, shipment: 0, total_shipment: 0 },
                intransit: { qty: 0, shipment: 0, total_shipment: 0 },
            },

            // filter dealer/status dari child (dipakai untuk card)
            tableFilter : { dealer_type: null, kode_dealer: null, status: null },

        }
    },
    computed : {
        

         highlightParams () {
                const { dealer_type, kode_dealer } = this.tableFilter
                return {
                    start_date: this.startDate,
                    end_date: this.endDate,
                    dealer_type,
                    kode_dealer
                }
            },
            
         highlightKey () {
                return JSON.stringify(this.highlightParams)
            },
            
        summaryCards () {
            const { sent, received, intransit } = this.highlight
            return [
                { key: 'sent',      title: 'Total QR Dikirim',    qty: sent.qty,      count: sent.shipment },
                { key: 'received',  title: 'QR Sudah Diterima',   qty: received.qty,  count: received.shipment },
                { key: 'intransit', title: 'QR Dalam Perjalanan', qty: intransit.qty, count: intransit.shipment, link: true },
            ]
        }


    },
    mounted() {
        this.fetchData();
        this.fetchHighlight();

    },
    beforeMount () {
        document.getElementById('content').style.background = '#F8F8F8';
    },
    beforeDestroy () {
        document.getElementById('content').style.background = '';
    },
    methods : {
        onCloseDate (dates) {
            if (!dates.length) return
            const fmt = (d) => moment(d).format('YYYY-MM-DD')
            this.startDate = fmt(dates[0])
            this.endDate = fmt(dates[1] || dates[0])
        },
        // klik link "dari X pengiriman" di card QR Dalam Perjalanan
        showInTransit () {
            this.$refs.qrIssue.setStatus('INTRANSIT')
        },
        showMetodeModal () {
            this.modal.showMetodeModal = true
        },
        handleEditData (data) {
            this.modal.showEditModal = true

            this.dataEdit.id = data.id
            this.dataEdit.package_code = data.package_code || data.package || data.code || ''
            this.dataEdit.kode_dealer = data.kode_dealer
            this.dataEdit.qty = data.qty
            this.dataEdit.sender_signature = data.sender_signature
        },

        fetchHighlight () {
            // buang param null supaya tidak terkirim sebagai "null"
            const params = {}
            Object.entries(this.highlightParams).forEach(([k, v]) => {
                if (v !== null && v !== '') params[k] = v
            })

            this.$http.get('/api/qrs/issue/highlight', { params })
            .then((resp) => {
                this.highlight = resp.data.data
            })
            .catch((err) => { console.log(err) })
        },
        
     
         updateTable () {
                this.$refs.qrIssue.generateDatas();
                this.fetchData()
                this.fetchHighlight()
                this.modal.showMetodeModal = false;
                this.modal.showEditModal = false;
            },
        fetchData() {
            if (this.$store.state.userData.userData.role !== 'USER SE') {
                this.$http.get(`/api/qrs/highlight`)
                .then((resp)=>{
                    this.saldoQr = resp.data.data.qty_after
                })
                .catch((err)=>{console.log(err)})
            } else {
                this.$http.get(`/api/qrs/highlight/dealer?start_date=${moment().format('YYYY-MM-DD')}&end_date=${moment().format('YYYY-MM-DD')}`)
                .then((resp)=>{
                    this.saldoQr = resp.data.data.qty_after
                })
                .catch((err)=>{console.log(err)})
            }
        },
    },
    watch : {
        // refetch hanya kalau tanggal / dealer berubah
        highlightKey () {
            this.fetchHighlight()
        }
    },
}
</script>

<style>
    .mpm-button {
        background-color :#F36F21 !important;
        color : white;
        height: 47px;
    }

    .mpm-button-outline {
        background-color :white !important;
        color : #F36F21;
        height: 47px;
    }

    .h-47px {
        height: 47px;
    }

    .btn-download-template {
        background-color: white;
        border: 1px solid #E2E8F0;
        padding: 0 16px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        font-size: 13px;
        cursor: pointer;
        font-weight: 500;
        color: #1F2937;
        height: 32px;
    }

    .btn-download-template:hover {
        background-color: #F8FAFC;
        color: #1F2937;
    }

    /* Date picker (pindahan dari child) */
    .qr-flatpickr-alt {
        border: none !important;
        outline: none !important;
        font-size: 13px !important;
        background: transparent !important;
        color: #1F2937 !important;
        min-width: 190px !important;
        height: 30px !important;
        padding: 0 !important;
        cursor: pointer !important;
    }

    .date-picker-wrapper {
        display: flex;
        align-items: center;
        background-color: white;
        border: 1px solid #E2E8F0;
        border-radius: 4px;
        padding: 0 10px;
        height: 32px;
    }

    .calendar-icon {
        color: #4B5563;
        font-size: 14px;
        margin-right: 6px;
    }

    /* Summary cards */
    .summary-card {
        background: white;
        border-radius: 8px;
        padding: 24px;
        height: 100%;
    }

    .summary-title {
        font-size: 14px;
        color: #4B5563;
    }

    .summary-value {
        font-size: 28px;
        font-weight: 600;
        color: #111827;
        line-height: 1.3;
    }

    .summary-divider {
        margin: 8px 0 12px;
        border-top: 1px solid #E5E7EB;
    }

    .summary-sub {
        font-size: 16px;
        color: #111827;
    }

    .summary-link {
        color: #F36F21;
        text-decoration: underline;
        cursor: pointer;
    }
</style>